<template>
    <f7-page>

        <f7-navbar :title="title" sliding>
        </f7-navbar>

        <div v-if="Presentation">
            <f7-card form class="bg-teal color-white">

                <f7-card-header>عنوان دوره:
                    {{ $root.farsiFormat(Presentation.course.title) }}
                </f7-card-header>

                <f7-card-content>
                    <f7-grid>
                        <f7-col width="100" :tablet-width="50">
                            <span class="key">{{ $root.__('Id') }}:</span> {{ Presentation.id }}
                        </f7-col>
                        <f7-col width="100" :tablet-width="50">
                            <span class="key">{{ $root.__('Presentation Days') }}:</span> {{ $root.farsiFormat(Presentation.days) }}
                        </f7-col>
                        <f7-col width="100" :tablet-width="50">
                            <span class="key">{{ $root.__('Start Date') }}:</span> {{ $root.farsiFormat(Presentation.start_date_jalali, true) }}
                        </f7-col>
                        <f7-col width="100" :tablet-width="50">
                            <span class="key">{{ $root.__('Number of Hours') }}:</span> {{ $root.farsiFormat(Presentation.duration) }}
                        </f7-col>
                        <f7-col width="100" :tablet-width="50">
                            <span class="key">{{ $root.__('Price(Rial)') }}:</span>
                            <span v-if="Presentation.discount_percent > 0">
                                <span class="changed">{{ $root.farsiFormat(Presentation.price.toLocaleString()) }}</span>
                                <span>{{ $root.farsiFormat(parseInt(Presentation.price - Presentation.price * Presentation.discount_percent / 100).toLocaleString()) }}</span>
                            </span>
                            <span v-else>{{ $root.farsiFormat(Presentation.price.toLocaleString()) }}</span>
                        </f7-col>
                    </f7-grid>
                </f7-card-content>
            </f7-card>

            <f7-card v-if="Presentation.course.prequireds.length > 0" form class="orange prequireds">
                <f7-card-header>{{ $root.__('Prequireds') }}</f7-card-header>
                <f7-card-content>
                    <f7-list>
                        <f7-list-item v-for="Prequired in Presentation.course.prequireds">
                            {{ $root.farsiFormat(Prequired.title) }}
                        </f7-list-item>
                    </f7-list>
                </f7-card-content>
            </f7-card>
        </div>

        <div v-if="!payment">
            <f7-list form>
                <f7-list-item>
                    <f7-label>{{ $root.__('FName') }}</f7-label>
                    <f7-input v-model="form_data.fname" type="text" :placeholder="$root.__('FName')" />
                </f7-list-item>
                <f7-list-item>
                    <f7-label>{{ $root.__('LName') }}</f7-label>
                    <f7-input v-model="form_data.lname" type="text" :placeholder="$root.__('LName')" />
                </f7-list-item>
                <f7-list-item>
                    <f7-label>{{ $root.__('National Code') }}</f7-label>
                    <f7-input v-model="form_data.national_code" type="text" :placeholder="$root.__('National Code')" />
                </f7-list-item>
                <f7-list-item>
                    <f7-label>{{ $root.__('Mobile') }}</f7-label>
                    <f7-input v-model="form_data.mobile" type="text" :placeholder="$root.__('Mobile')" />
                </f7-list-item>
                <f7-list-item checkbox name="my-checkbox" v-model="form_data.accept_law"
                              :title="$root.__('Accept law')">
                </f7-list-item>
                <f7-list-item>
                    <f7-link href="#" @click="showLaw" class="button">
                        {{ $root.__('Read Law') }}
                    </f7-link>
                </f7-list-item>
            </f7-list>

            <f7-block>
                <f7-grid>
                    <f7-col>
                        <f7-button raised fill color="blue" @click="submit">ثبت</f7-button>
                    </f7-col>
                    <f7-col>
                        <f7-button raised fill color="gray" @click="cancel">انصراف</f7-button>
                    </f7-col>
                    <f7-col>
                    </f7-col>
                    <f7-col>
                    </f7-col>
                </f7-grid>
            </f7-block>
        </div>

        <form v-if="payment" :action="payment.gatewayUrl" method="post" id="bank_form">
            <input type='hidden' name='invoiceNumber' :value='payment.invoiceNumber' />
            <input type='hidden' name='invoiceDate' :value='payment.invoiceDate' />
            <input type='hidden' name='amount' :value='payment.amount' />
            <input type='hidden' name='terminalCode' :value='payment.terminalCode' />
            <input type='hidden' name='merchantCode' :value='payment.merchantCode' />
            <input type='hidden' name='redirectAddress' :value='payment.redirectAddress' />
            <input type='hidden' name='timeStamp' :value='payment.timeStamp' />
            <input type='hidden' name='action' :value='payment.action' />
            <input type='hidden' name='sign' :value='payment.sign' />
        </form>

    </f7-page>
</template>

<script>
    export default {
        data: function () {
            let self = this;

            return {
                title: self.$root.__('Register in Presentation'),
                presentation_id: 0,
                form_data: {
                    presentation_id: '',
                    fname: '',
                    lname: '',
                    mobile: '',
                    national_code: '',
                    accept_law: false,
                },
                payment: null
            }
        },
        computed: {
            Presentation: function () {
                let self = this;

                return self.$store.getters.item('Presentations', self.presentation_id);
            }
        },
        methods: {
            showLaw: function() {
                let self = this;

                window.open(self.$store.state._wordpress_url + 'terms-of-service/', '_blank');
            },
            cancel: function () {
                let self = this;

                localStorage.clear();
                window.location = self.$store.state._wordpress_url;
            },
            submit: function () {
                let self = this;

                if (!self.$root.validate(self.form_data)) {
                    self.$f7.addNotification({
                        message: self.$root.__('Please fill all fields!'),
                        hold: 4000,
                        button: {text: self.$root.__('Close'), color: 'red', close: true}
                    });
                    return false;
                }

                // Send event to google analytics
                if (window.ga)
                    window.ga('send', 'event', { eventCategory: 'lmsOrder', eventAction: 'Click', eventLabel: 'CourseOrder'});


                self.$store.dispatch('DO', {
                    task: 'guest/order',
                    data: self.form_data,
                    silent: false,
                    wp: true,
                    callback: function (e) {
                        self.payment = e;

                        let ls = JSON.parse(localStorage.getItem('mftsk-lms')) || {};
                        ls.redirect = '/bank-return/?presentation_id=' + self.presentation_id + '&order_id=' + e.id;
                        localStorage.setItem('mftsk-lms', JSON.stringify(ls));

                        //console.log(e);
                        window.setTimeout(function () {
                            self.$$('#bank_form')[0].submit();
                        }, 500);
                    }
                });
            }
        },
        created: function () {
            let self = this;

            self.presentation_id = parseInt(self.$route.query.presentation_id);
            if (!self.Presentation) {
                self.$store.dispatch('GET', {silent: false, key: 'Presentations', id: self.presentation_id});
            }

            self.form_data.presentation_id = self.presentation_id;
        }
    }
</script>


// WEBPACK FOOTER //
// enrollment-form.vue?f1c0b15c